import React from 'react';
import EventsTable from './EventsTable';

/*
 * RealtimeEvents — thin wrapper around the reskinned EventsTable.
 *
 * The Console reskin moved everything the old header-filter table did into
 * EventsTable itself (filter toolbar with type chips + search + gate/site
 * selects, the DataTable, reskinned pagination, the subtle loading overlay, and
 * the read-only detail Drawer). The column defs, loading/empty states, and the
 * per-crossing detail view all live there now, so this component just forwards
 * the Reset List plumbing (toggleReset/reset) from TransactionMonitor.
 *
 * Redux wiring, the 3-min incremental poll, the poll-abort while filtered/
 * sorted/paged, and the onsite-count logic are all unchanged.
 */
export default function RealtimeEvents({ toggleReset, reset, toggleDownloadModal }) {
  return <EventsTable toggleReset={toggleReset} reset={reset} toggleDownloadModal={toggleDownloadModal} />
}
